import axios from '../../../../utils/request';

function GET_LIST(params) {
    return axios.post("/statistics/Important/index",{...params
    } )
}

export default {
    GET_LIST
};
